import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components/macro'
import { media } from 'utilities/styled'

import AppLayoutContainer from 'components/redux-containers/app-layout-container'
import PageHeader from 'components/organisms/page-header'
import ThuistaxatieTable from './thuistaxatie-table'

const Container = styled.div`
  background: ${({ theme }) => theme.colors.brandFoxtrot};
  padding: 0 ${({ theme }) => theme.sizeByFactor(2.5)};

  ${media.desktop`
    padding: 0 ${({ theme }) => theme.sizeByFactor(7.5)};
  `};
`

function ThuistaxatieView({ getThuistaxatieRequests, thuistaxatieRequests }) {
  const { t } = useTranslation()

  useEffect(() => {
    try {
      getThuistaxatieRequests()
    } catch (error) {
      console.error('Error fetching thuistaxatie requests:', error)
    }
  }, [getThuistaxatieRequests])

  return (
    <AppLayoutContainer pageTitle={t('thuistaxatie.title')}>
      <Container>
        <PageHeader
          mainTitle={t('thuistaxatie.title')}
          hasBorderBottom={false}
        />
        <ThuistaxatieTable
          items={thuistaxatieRequests?.data?.data?.data}
          error={thuistaxatieRequests?.error}
        />
      </Container>
    </AppLayoutContainer>
  )
}

ThuistaxatieView.propTypes = {
  getThuistaxatieRequests: PropTypes.func.isRequired,
  thuistaxatieRequests: PropTypes.shape({
    loading: PropTypes.bool,
    error: PropTypes.any,
    data: PropTypes.shape({
      data: PropTypes.shape({
        data: PropTypes.arrayOf(
          PropTypes.shape({
            id: PropTypes.number.isRequired,
            lead_info: PropTypes.shape({
              licenseplate: PropTypes.string.isRequired,
              firstname: PropTypes.string.isRequired,
              lastname: PropTypes.string.isRequired,
              phone: PropTypes.string.isRequired,
            }).isRequired,
            created_at: PropTypes.string.isRequired,
          }),
        ),
      }),
    }),
  }),
}

ThuistaxatieView.defaultProps = {
  thuistaxatieRequests: null,
}

export default ThuistaxatieView
